import React, { createContext, useMemo, useState } from "react";
import messages from "../locales";

const defaultLocale = navigator.language.split(/[-_]/)[0]; // "fr"; Get the browser language

const LanguageContext = createContext({
  locale: defaultLocale,
  changeLanguage: () => {},
});

export function LanguageProvider({ children }) {
  const [locale, setLocale] = useState(defaultLocale);

  const changeLanguage = (lng) => {
    setLocale(lng);
  };

  const contextValue = useMemo(
    () => ({
      locale,
      changeLanguage,
    }),
    [locale],
  );

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => React.useContext(LanguageContext);

export const getMessagesForLocale = (locale) => messages[locale];
